import { render, staticRenderFns } from "./ChatSelector.vue?vue&type=template&id=b02a52a0&scoped=true"
import script from "./ChatSelector.vue?vue&type=script&lang=js"
export * from "./ChatSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatSelector.vue?vue&type=style&index=0&id=b02a52a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a52a0",
  null
  
)

export default component.exports